export default __webpack_public_path__ + "static/media/ramadan2.91be779f.jpg";